// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/img/ArrowDown.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-flex-card-parent {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.container-card-one {
  display: flex;
  align-items: center;
  gap: 24px;
  height: auto;
  width: 100%;
  border-radius: 8px;
  border: 2px solid #e2e2e2;
  background: #fff;
  box-shadow: 4px 30px 64px 0px rgba(95, 109, 126, 0.1);
  padding: 32px;
  box-sizing: border-box;
}
.kreiraj-button,
.date-container,
.select-event-intenzivi,
.btn-create-intenzivnost {
  display: flex;
  align-items: center;
  justify-content: center;
}
.input-row,
.header-container,
.bottom-container,
.header-section-intenzivi {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.input-row {
  gap: 16px;
  margin-bottom: 24px;
}
.kreiraj-button {
  padding: 8px 16px 8px 16px;
  gap: 8px;
  text-align: center;
  transition: backgroundColor 300ms ease-in-out;
}
.kreiraj-button:hover,
.select-radionice:hover {
  cursor: pointer;
  background-color: #d1d9e2;
}
.kreiraj-button,
.select-radionice {
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: -0.001em;
  color: #5f6d7e;
  border: 1px solid #d1d9e2;
  background-color: #ffffff;
  border-radius: 4px;
  height: 40px;
}
.select-radionice {
  padding: 6px 48px;
  text-align: left;
  appearance: none;
  -webkit-appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position-x: 95%;
  background-position-y: center;
  background-repeat: no-repeat;
}
.select-radionice:focus {
  border-color: #d1d9e2;
  outline: none;
}

.container-card-one:hover {
  border: 2px solid #5f6d7e;
  transition: border 300ms ease-in-out;
  cursor: pointer;
}
.modal-btn-success {
  background-color: #cb9c2d;
  color: #ffffff;
  border-radius: 4px;
  border: none;
  padding: 8px 16px 8px 16px;
  height: 52px;
  width: 100%;
  max-width: 200px;
  font-size: 15px;
  letter-spacing: -0.001em;
  text-align: center;
  cursor: pointer;
}
.modal-btn-success:hover {
  opacity: 0.89;
}
.header-container {
  gap: 15px;
}
.container-one-image {
  height: auto;
  width: auto;
}
.bottom-container {
  gap: 48px;
}
.container-flex-card {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  gap: 50px;
}
.text-card-one {
  overflow: hidden;
  color: var(--gray-50, #5f6d7e);
  text-overflow: ellipsis;
  font-weight: 500;
  text-align: inherit;
  transform: translateY(-30px);
}
.seperator-card-two {
  height: 17px;
  background: #e2e2e2;
}
.overflow-container-navigation {
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: thin;
  scrollbar-color: gold #e2e2e2;
  border-bottom: 1px solid #e2e2e2;
}
.subpage-wrapper {
  gap: 36px;
  display: flex;
  flex-direction: column;
  width: 100%;
}
.btn-intenzivi-card {
  border-radius: 4px;
  border: 1px solid #d1d9e2;
  background: #fff;
  height: 40px;
  padding: 8px 16px;
  width: 168px;
}
.date-container {
  color: #9fa7b2;
  gap: 8px;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -0.014px;
}
.tab-navigator {
  margin-bottom: 24px;
}
.select-event-intenzivi {
  width: 193px;
  height: 42px;
  padding: 8px 22px;
  border-radius: 4px;
  border: 1px solid #d1d9e2;
  background: #fff;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background: transparent;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right center;
  color: var(--gray-50, #5f6d7e);

  background-position: calc(100% - 16px) center;
}
.select-event-intenzivi,
.btn-create-intenzivnost,
.btn-intenzivi-card,
.text-card-one,
.modal-btn-success {
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.016px;
}
.select-event-intenzivi::after {
  content: "";
  display: inline-block;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0.4em 0.4em 0;
  border-color: #5f6d7e transparent transparent transparent;
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  background-color: #ffffff;
}
.btn-create-intenzivnost {
  border: none;
  background: none;
  color: var(--gray-50, #5f6d7e);
  cursor: pointer;
  padding: 8px 16px;
  gap: 8px;
  flex-shrink: 0;
  border-radius: 4px;
  border: 1px solid #d1d9e2;
  background: #fff;
  cursor: pointer;
}

.header-section-intenzivi {
  gap: 16px;
  margin-bottom: 24px;
}

.select-container {
  width: fit-content;
}

.supervision-filters-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 110px;
  background-color: #ffffff;
  box-shadow: 4px 30px 64px 0px rgba(95, 109, 126, 0.1);
  border-radius: 4px;
  border: 1px solid #cfd7e0;
  margin-bottom: 30px;
  padding: 20px;
  box-sizing: border-box;
}

.supervision-select-labels {
  text-transform: uppercase;
  font-size: 12px;
  color: #7e818c;
  font-weight: 600;
  font-family: Inter;
}

.supervision-selects-container {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  width: 70%;
  height: 100%;
}

.supervision-select-container {
  display: flex;
  flex-direction: column;
  gap: 5px;
  align-items: baseline;
  width: 100%;
}

.filter-btns {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  gap: 10px;
  width: 30%;
  height: 100%;
}

@media screen and (max-width: 800px) {
  .image-container-pojedini {
    margin-bottom: 30px;
  }
  .header-section-intenzivi {
    justify-content: space-between;
  }
}
@media screen and (max-width: 765px) {
  .container-card-one {
    flex-direction: column;
  }
  .pregled-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
}

@media screen and (max-width: 470px) {
  .header-section-intenzivi {
    flex-direction: column;
  }
  .buttonContainer-intenzivnost,
  .btn-create-intenzivnost,
  .select-container {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/scenes/programi/programi.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,qDAAqD;EACrD,aAAa;EACb,sBAAsB;AACxB;AACA;;;;EAIE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;;;;EAIE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,QAAQ;EACR,kBAAkB;EAClB,6CAA6C;AAC/C;AACA;;EAEE,eAAe;EACf,yBAAyB;AAC3B;AACA;;EAEE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,yDAAuD;EACvD,0BAA0B;EAC1B,6BAA6B;EAC7B,4BAA4B;AAC9B;AACA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,0BAA0B;EAC1B,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,SAAS;AACX;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,SAAS;AACX;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,2BAA2B;EAC3B,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,4BAA4B;AAC9B;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,6BAA6B;EAC7B,gCAAgC;AAClC;AACA;EACE,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,cAAc;EACd,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;AAC1B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,uBAAuB;EACvB,mDAA+C;EAC/C,4BAA4B;EAC5B,iCAAiC;EACjC,8BAA8B;;EAE9B,6CAA6C;AAC/C;AACA;;;;;EAKE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,QAAQ;EACR,SAAS;EACT,mBAAmB;EACnB,2BAA2B;EAC3B,yDAAyD;EACzD,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,oBAAoB;EACpB,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;EACf,iBAAiB;EACjB,QAAQ;EACR,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,yBAAyB;EACzB,qDAAqD;EACrD,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,UAAU;EACV,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,yBAAyB;EACzB,SAAS;EACT,UAAU;EACV,YAAY;AACd;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,8BAA8B;EAChC;AACF;AACA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;;;IAGE,WAAW;EACb;AACF","sourcesContent":[".container-flex-card-parent {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.container-card-one {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n  height: auto;\n  width: 100%;\n  border-radius: 8px;\n  border: 2px solid #e2e2e2;\n  background: #fff;\n  box-shadow: 4px 30px 64px 0px rgba(95, 109, 126, 0.1);\n  padding: 32px;\n  box-sizing: border-box;\n}\n.kreiraj-button,\n.date-container,\n.select-event-intenzivi,\n.btn-create-intenzivnost {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.input-row,\n.header-container,\n.bottom-container,\n.header-section-intenzivi {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n.input-row {\n  gap: 16px;\n  margin-bottom: 24px;\n}\n.kreiraj-button {\n  padding: 8px 16px 8px 16px;\n  gap: 8px;\n  text-align: center;\n  transition: backgroundColor 300ms ease-in-out;\n}\n.kreiraj-button:hover,\n.select-radionice:hover {\n  cursor: pointer;\n  background-color: #d1d9e2;\n}\n.kreiraj-button,\n.select-radionice {\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: -0.001em;\n  color: #5f6d7e;\n  border: 1px solid #d1d9e2;\n  background-color: #ffffff;\n  border-radius: 4px;\n  height: 40px;\n}\n.select-radionice {\n  padding: 6px 48px;\n  text-align: left;\n  appearance: none;\n  -webkit-appearance: none;\n  background-image: url(\"../../assets/img/ArrowDown.png\");\n  background-position-x: 95%;\n  background-position-y: center;\n  background-repeat: no-repeat;\n}\n.select-radionice:focus {\n  border-color: #d1d9e2;\n  outline: none;\n}\n\n.container-card-one:hover {\n  border: 2px solid #5f6d7e;\n  transition: border 300ms ease-in-out;\n  cursor: pointer;\n}\n.modal-btn-success {\n  background-color: #cb9c2d;\n  color: #ffffff;\n  border-radius: 4px;\n  border: none;\n  padding: 8px 16px 8px 16px;\n  height: 52px;\n  width: 100%;\n  max-width: 200px;\n  font-size: 15px;\n  letter-spacing: -0.001em;\n  text-align: center;\n  cursor: pointer;\n}\n.modal-btn-success:hover {\n  opacity: 0.89;\n}\n.header-container {\n  gap: 15px;\n}\n.container-one-image {\n  height: auto;\n  width: auto;\n}\n.bottom-container {\n  gap: 48px;\n}\n.container-flex-card {\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-start;\n  flex-direction: column;\n  gap: 50px;\n}\n.text-card-one {\n  overflow: hidden;\n  color: var(--gray-50, #5f6d7e);\n  text-overflow: ellipsis;\n  font-weight: 500;\n  text-align: inherit;\n  transform: translateY(-30px);\n}\n.seperator-card-two {\n  height: 17px;\n  background: #e2e2e2;\n}\n.overflow-container-navigation {\n  display: flex;\n  overflow-x: auto;\n  overflow-y: hidden;\n  scrollbar-width: thin;\n  scrollbar-color: gold #e2e2e2;\n  border-bottom: 1px solid #e2e2e2;\n}\n.subpage-wrapper {\n  gap: 36px;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n.btn-intenzivi-card {\n  border-radius: 4px;\n  border: 1px solid #d1d9e2;\n  background: #fff;\n  height: 40px;\n  padding: 8px 16px;\n  width: 168px;\n}\n.date-container {\n  color: #9fa7b2;\n  gap: 8px;\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  letter-spacing: -0.014px;\n}\n.tab-navigator {\n  margin-bottom: 24px;\n}\n.select-event-intenzivi {\n  width: 193px;\n  height: 42px;\n  padding: 8px 22px;\n  border-radius: 4px;\n  border: 1px solid #d1d9e2;\n  background: #fff;\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  background: transparent;\n  background: url(../../assets/img/ArrowDown.png);\n  background-repeat: no-repeat;\n  background-position: right center;\n  color: var(--gray-50, #5f6d7e);\n\n  background-position: calc(100% - 16px) center;\n}\n.select-event-intenzivi,\n.btn-create-intenzivnost,\n.btn-intenzivi-card,\n.text-card-one,\n.modal-btn-success {\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.016px;\n}\n.select-event-intenzivi::after {\n  content: \"\";\n  display: inline-block;\n  width: 0;\n  height: 0;\n  border-style: solid;\n  border-width: 0.4em 0.4em 0;\n  border-color: #5f6d7e transparent transparent transparent;\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  pointer-events: none;\n  background-color: #ffffff;\n}\n.btn-create-intenzivnost {\n  border: none;\n  background: none;\n  color: var(--gray-50, #5f6d7e);\n  cursor: pointer;\n  padding: 8px 16px;\n  gap: 8px;\n  flex-shrink: 0;\n  border-radius: 4px;\n  border: 1px solid #d1d9e2;\n  background: #fff;\n  cursor: pointer;\n}\n\n.header-section-intenzivi {\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.select-container {\n  width: fit-content;\n}\n\n.supervision-filters-container {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 110px;\n  background-color: #ffffff;\n  box-shadow: 4px 30px 64px 0px rgba(95, 109, 126, 0.1);\n  border-radius: 4px;\n  border: 1px solid #cfd7e0;\n  margin-bottom: 30px;\n  padding: 20px;\n  box-sizing: border-box;\n}\n\n.supervision-select-labels {\n  text-transform: uppercase;\n  font-size: 12px;\n  color: #7e818c;\n  font-weight: 600;\n  font-family: Inter;\n}\n\n.supervision-selects-container {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  width: 70%;\n  height: 100%;\n}\n\n.supervision-select-container {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  align-items: baseline;\n  width: 100%;\n}\n\n.filter-btns {\n  display: flex;\n  align-items: flex-end;\n  justify-content: flex-end;\n  gap: 10px;\n  width: 30%;\n  height: 100%;\n}\n\n@media screen and (max-width: 800px) {\n  .image-container-pojedini {\n    margin-bottom: 30px;\n  }\n  .header-section-intenzivi {\n    justify-content: space-between;\n  }\n}\n@media screen and (max-width: 765px) {\n  .container-card-one {\n    flex-direction: column;\n  }\n  .pregled-wrapper {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n  }\n}\n\n@media screen and (max-width: 470px) {\n  .header-section-intenzivi {\n    flex-direction: column;\n  }\n  .buttonContainer-intenzivnost,\n  .btn-create-intenzivnost,\n  .select-container {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
